import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Table, Button, Form, Alert, Badge, Modal } from 'react-bootstrap';
import axios from 'axios';
import { useNavigate } from "react-router-dom";

function Whitelist({ user }) {
  const [whitelist, setWhitelist] = useState([]);
  const [showAddModal, setShowAddModal] = useState(false);
  const [newNumber, setNewNumber] = useState({ phoneNumber: '', name: '' });
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');

    const navigate = useNavigate();

    const callContact = (phone) => {
      navigate(`/make-call?number=${encodeURIComponent(phone)}`);
    };

  useEffect(() => {
    fetchWhitelist();
  }, []);

  const fetchWhitelist = async () => {
    try {
      const token = localStorage.getItem('token');
      const response = await axios.get('/api/whitelist', {
        headers: { Authorization: `Bearer ${token}` }
      });
      setWhitelist(response.data.whitelist || []);
    } catch (error) {
      console.error('Error fetching whitelist:', error);
    }
  };

  const handleAddNumber = async (e) => {
    e.preventDefault();
    setMessage('');

    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/whitelist', newNumber, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessage('Number added to whitelist successfully!');
      setMessageType('success');
      setNewNumber({ phoneNumber: '', name: '' });
      setShowAddModal(false);
      fetchWhitelist();
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage(error.response?.data?.message || 'Failed to add number');
      setMessageType('danger');
    }
  };

  const handleRemove = async (phoneNumber) => {
    if (!window.confirm('Remove this number from whitelist?')) return;

    try {
      const token = localStorage.getItem('token');
      await axios.delete(`/api/whitelist/${phoneNumber}`, {
        headers: { Authorization: `Bearer ${token}` }
      });
      setMessage('Number removed from whitelist');
      setMessageType('info');
      fetchWhitelist();
      setTimeout(() => setMessage(''), 3000);
    } catch (error) {
      setMessage('Failed to remove number');
      setMessageType('danger');
    }
  };

  return (
    <Container className="mainWrapper">
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <h2 className="text-light fs-5">
              <i className="fas fa-check-circle me-2 text-success"></i>
              Trusted Contacts
            </h2>
            <Button variant="success" onClick={() => setShowAddModal(true)}>
              <i className="fas fa-plus me-2"></i>
              Add Contact
            </Button>
          </div>
        </Col>
      </Row>

      {message && (
        <Row className="mb-3">
          <Col>
            <Alert variant={messageType}>{message}</Alert>
          </Col>
        </Row>
      )}

      <Row>
        <Col>
          <Card>
            <Card.Body>
              <p className="text-muted mb-3">
                <i className="fas fa-info-circle me-2"></i>
                Numbers on your whitelist can call you directly without
                authentication.
              </p>

              {whitelist.length === 0 ? (
                <div className="text-center py-5">
                  <i className="fas fa-users fa-4x text-muted mb-3"></i>
                  <p className="text-muted">No trusted contacts yet</p>
                  <p className="text-muted small">
                    Add numbers manually or they'll be auto-added after
                    successful authentication
                  </p>
                </div>
              ) : (
                <Table responsive hover>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Phone Number</th>
                      <th>Added On</th>
                      {/* <th>Last Called</th> */}
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {whitelist.map((contact) => (
                      <tr key={contact._id} className="whitelist-item">
                        <td>
                          <i className="fas fa-user-check text-success me-2"></i>
                          {contact.name}
                        </td>
                        <td>
                          <Badge bg="success">{contact.phoneNumber}</Badge>
                        </td>
                        <td>
                          {new Date(contact.addedAt).toLocaleDateString()}
                        </td>
                        {/* <td>
                          {contact.lastCalled
                            ? new Date(contact.lastCalled).toLocaleString()
                            : "Never"}
                        </td> */}
                        <td className="text-center">
                          <div className="d-flex justify-content-center gap-3">
                            <i
                              className="fas fa-phone text-success cursor-pointer"
                              title="Call"
                              style={{ fontSize: "16px" }}
                              onClick={() => callContact(contact.phoneNumber)}
                            />

                            <i
                              className="fas fa-trash text-danger cursor-pointer"
                              title="Remove"
                              style={{ fontSize: "16px" }}
                              onClick={() => handleRemove(contact.phoneNumber)}
                            />
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              )}
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Add Contact Modal */}
      <Modal show={showAddModal} onHide={() => setShowAddModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Add Trusted Contact</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleAddNumber}>
            <Form.Group className="mb-3">
              <Form.Label>Contact Name</Form.Label>
              <Form.Control
                type="text"
                value={newNumber.name}
                onChange={(e) =>
                  setNewNumber({ ...newNumber, name: e.target.value })
                }
                placeholder="John Doe"
                required
              />
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label>Phone Number</Form.Label>
              <Form.Control
                type="tel"
                value={newNumber.phoneNumber}
                onChange={(e) =>
                  setNewNumber({ ...newNumber, phoneNumber: e.target.value })
                }
                placeholder="+1234567890"
                required
              />
            </Form.Group>
            <div className="d-flex justify-content-end gap-2">
              <Button
                variant="secondary"
                onClick={() => setShowAddModal(false)}
              >
                Cancel
              </Button>
              <Button variant="success" type="submit">
                <i className="fas fa-check me-2"></i>
                Add Contact
              </Button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default Whitelist;
